
import store from '../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const waitingProcessedWidgetsData = data;
  store.dispatch('fetchWaitingProcessedDataWidgets', waitingProcessedWidgetsData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('user-widgets/waiting-to-be-processed')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/widgets/fetchWaitingProcessedWidgets.js